/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab63f49f3262af83b926e204475086f6>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "ShowMoreHorizontal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for secondary/tertiary more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ShowMoreHorizontalIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.25 6.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M0 6a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 0 6m6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M4.75 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M9.5 6A1.25 1.25 0 1 1 12 6a1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"/><path fill="currentcolor" d="M1.5 6A.25.25 0 1 1 1 6a.25.25 0 0 1 .5 0m4.75 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M11 6a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"/>`,
  type: 'utility'
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var _default = exports.default = ShowMoreHorizontalIcon;